<template>
  <div class="recap">
    <b-card no-body class="recap__wrapper">
      <b-card-header v-if="show_header" class="recap__header">
        <div class="recap__header-element recap__header-element--first">
          <div class="recap__header-item">
            <vb-icon class="recap__header-icon mr-1" :name="'calendar'" :color="sass('primary')" :size="16" />
            <span>{{ header.checkin }} - {{ header.checkout }}</span>
          </div>
          <div class="recap__header-item">
            <vb-icon class="recap__header-icon mr-1" :name="'occupants'" :color="sass('primary')" :size="16" />
            <span class="semibold">{{ header.adults }}</span>
            <span class="ml-1" v-if="header.children">e {{ header.children }}</span>
          </div>
        </div>
        <div class="recap__header-element recap__header-element--second">
          <div class="recap__header-item recap__header-item--hotel">
            <vb-icon class="recap__header-icon mr-1" :name="'pin'" :color="sass('primary')" :size="12" />
            <span class="semibold">{{ header.hotel_name }}</span>
            <span>{{ header.hotel_address }}</span>
          </div>
        </div>
      </b-card-header>
      <b-card-body>
        <div class="recap__room">
          <div class="recap__room-head">
            <span class="recap__room-title">{{ property_data.room.name }}</span>
          </div>
          <div class="recap__rates">
            <div class="recap__rate">
              <div class="recap__rate-info">
                <refundability
                  class="recap__rate-refundable"
                  :cancellation="property_data.rate.refundable_before"
                />
                <div
                  v-for="(amenity, amenity_index) in property_data.rate.amenities"
                  :key="_uid+'_amenity_'+amenity_index"
                  class="recap__rate-amenity"
                >
                  <amenity
                    :item="amenity"
                    :type="'rates'"
                  />
                </div>
                <div class="recap__rate-bed">
                  <vb-icon class="recap__rate-bed_icon" :name="'doublebed'" :color="sass('gray-600')" :size="14" />
                  <span>{{ property_data.bed_type.description }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-card-text v-if="show_footer" class="recap__price">
          <span>include gestione e assistenza</span>
          <span>€ {{ property_data.live_price }}</span>
        </b-card-text>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { parse_date } from '@utilities/commons'
import Refundability from '@liveeps/components/atoms/refundability'
import Amenity from "@liveeps/components/atoms/amenity"

export default {
  name: 'card-recap',

  components: {
    'refundability': Refundability,
    'amenity': Amenity,
  },

  props: {
    property_data: Object,
    show_header: {
      type: Boolean,
      default: true
    },
    show_footer: {
      type: Boolean,
      default: true
    },
    show_matching: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      // stato del modulo liveeps
      selected_property: state => state.liveeps.selected_property,
      selected_solution: state => state.liveeps.selected_solution,
    }),

    // Genera l'header della card recap
    header() {
      const { name, location} = this.selected_property,
            { occupancy, dates} = this.selected_solution,
            { checkin, checkout } = dates

      const { adults, children } = occupancy.reduce(
          (total, item) => {
            total.adults += item.adults
            total.children += item.children.length
            return total
          },
          { adults: 0, children: 0 }
      )

      const adults_label = adults > 1 ? 'adulti' : 'adulto'
      const children_label = children > 1 ? 'bambini' : 'bambino'

      const get_date = (date) => {
        const parsed = parse_date(date)
        return `${parsed.day_number} ${parsed.month_string} ${parsed.year}`
      }

      return {
        checkin: get_date(checkin),
        checkout: get_date(checkout),
        adults: `${adults} ${adults_label}`,
        children: children > 0 ? `${children} ${children_label}` : null,
        hotel_name: name,
        hotel_address: `${location.address}, ${location.zip} ${location.city} (${location.province_state})`
      }
    },
  },

  created() {
  },

  mounted() {
  },

  watch: {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .recap {

    @media print {
      border-radius: $border-radius-lg * 2;
      border: 1px solid $gray-300;
    }

    &__wrapper {
      border-radius: $border-radius-lg * 2;
      border: none;
    }

    &__header {
      $this_recap_header: &;
      background-color: $selected;
      border-bottom: 1px solid $gray-300;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: $grid-gutter-20;

      &:first-child {
        border-radius: $border-radius-lg * 2 $border-radius-lg * 2 0 0;
      }

      &-element {

        &--first {
          display: flex;
          align-items: center;
        }
      }

      &-item {
        display: flex;
        align-items: center;
        margin-left: 15px;

        &:first-child {
          margin-left: 0;
        }

        @at-root #{$this_recap_header}-element--first & {
          font-weight: $vb-font-weight-semibold;
        }

        &--hotel {
          font-size: $font-size-md;

          span {
            &:last-child {
              margin-left: $grid-gutter-width / 3;
            }
          }
        }
      }
    }

    &__room {
      border-top: 1px solid $gray-300;
      margin-top: $grid-gutter-width / 3;
      padding-top: $grid-gutter-width / 3;

      &:first-child {
        padding-top: 0;
        margin-top: 0;
        border-top: 0;
      }

      &-head {
        display: flex;
        align-items: center;
        font-weight: $vb-font-weight-semibold;
      }
    }

    &__rates {
      margin-left: $grid-gutter-width / 6;
      margin-top: $grid-gutter-width / 3;
    }

    &__rate {
      border-top: 1px solid $gray-200;
      margin-top: $grid-gutter-width / 3;
      padding-top: $grid-gutter-width / 3;
      text-align: center;

      @include media-breakpoint-up(md) {
        text-align: left;
      }

      &:first-child {
        margin-top: 0;
        padding-top: 0;
        border-top: 0;
      }

      &-info {
        color: $gray-600;
        font-size: $font-size-md;

        @include media-breakpoint-up(sm) {
          display: flex;
          align-items: center;
        }
      }

      &-refundable {
        margin-right: $grid-gutter-width / 3;
      }

      &-amenity {
        margin-right: $grid-gutter-width / 4;
      }

      &-bed {
        display: flex;
        align-items: center;
        line-height: normal;

        &_icon {
          margin-top: 2px;
          margin-right: $grid-gutter-width / 6;
        }
      }
    }

    &__price {
      border-top: 1px solid $gray-200;
      padding-top: $grid-gutter-width / 3;
      margin-top: $grid-gutter-width / 3;

      span {
        &:first-child {
          color: $gray-500;
          font-size: $font-size-md;
          margin-right: $grid-gutter-width / 3;
        }
        &:last-child {
          color: var(--primary);
          font-size: $font-size-lg;
          font-weight: $vb-font-weight-semibold;
        }
      }
    }
  }

</style>